/**
 * Converts HTML to plain text.
 *
 * @param  {string} html HTML to convert.
 * @returns {string}      Converted HTML.
 */
export default (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    return tmp.innerText;
};
